import MenuItemSelector, {
  MenuItemSelectorOption,
} from "../../../MenuItemSelector";

import styles from "./DesktopCardSelector.module.scss";

export interface DesktopCardSelectorProps {
  cardId: API.CardId;
  cards: API.Card[];
  onChange: (id: API.CardId) => void;
}

const DesktopCardSelector = ({
  cardId,
  cards,
  onChange,
}: DesktopCardSelectorProps): JSX.Element => {
  const options: MenuItemSelectorOption[] = cards.map((card) => ({
    value: card.id,
    label: `${card.name} - ${card.last_four_digits}`,
  }));
  return (
    <div className={styles.container}>
      <MenuItemSelector
        options={options}
        selected={cardId}
        onSelect={onChange as (cardId: string) => void}
        label="Card"
        labelIcon="narmi-icon-credit-card1"
      />
    </div>
  );
};

export default DesktopCardSelector;
